<div class="service-header-wrapper">
	<h2 class="mat-heading" style="flex: 2">{{ 'sales.orders.title' | translate }}</h2>
	<div class="service-header-buttons">
		<header-sub-menu [favoriteItems]="favoriteItems"></header-sub-menu>
	</div>
</div>
